import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Music, Star } from "lucide-react";

export default function ArtistCard({ artist, index = 0 }) {
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.08 }}
      data-testid="artist-card"
      onClick={() => navigate(`/artistes/${artist.id}`)}
      className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-[#C9A24B]/60 bg-[#121216] cursor-pointer transition-all duration-500 gold-glow"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={artist.image_url}
          alt={artist.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/30 to-transparent" />
        {artist.trend && (
          <span className="absolute top-3 right-3 gold-bg text-black text-[10px] font-bold px-3 py-1 rounded-full flex items-center gap-1">
            <Star size={11} /> TENDANCE
          </span>
        )}
        <span className="absolute top-3 left-3 glass text-[#C9A24B] text-[10px] px-3 py-1 rounded-full flex items-center gap-1 border border-[#C9A24B]/30">
          <MapPin size={11} /> {artist.continent}
        </span>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <h3 className="font-serif text-2xl text-white font-semibold">{artist.name}</h3>
        <p className="text-[#C9A24B] text-xs uppercase tracking-wider flex items-center gap-1 mt-1">
          <Music size={12} /> {artist.genre} · {artist.style}
        </p>
        <p className="text-[#A19E95] text-sm mt-2">{artist.price_display}</p>
        <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="inline-block border border-[#C9A24B]/60 text-[#C9A24B] text-xs tracking-wider uppercase px-5 py-2 rounded-full">
            Voir le profil
          </span>
        </div>
      </div>
    </motion.div>
  );
}
